import React, { useEffect, useMemo, useState } from 'react';
import { partitionAdminContent } from './adminContentFilter';

export default function AdminFilteredContentList({
  context,
  filter,
  getKey,
  kind,
  records,
  renderRecord,
}) {
  const [showOutside, setShowOutside] = useState(false);
  const groups = useMemo(
    () => partitionAdminContent(records, kind, filter, context),
    [context, filter, kind, records],
  );

  useEffect(() => {
    setShowOutside(false);
  }, [filter?.regionId, filter?.minLevel, filter?.maxLevel]);

  if (!filter?.active) {
    return records.map((record, index) => (
      <React.Fragment key={getKey(record, index)}>
        {renderRecord(record, index)}
      </React.Fragment>
    ));
  }

  const renderGroup = (values, offset = 0) => values.map((record, index) => (
    <React.Fragment key={getKey(record, index + offset)}>
      {renderRecord(record, index + offset)}
    </React.Fragment>
  ));

  return (
    <>
      <section className="admin-filter-group" aria-label="Matching content">
        <h3>Matches <span>{groups.match.length}</span></h3>
        {groups.match.length
          ? renderGroup(groups.match)
          : <p className="admin-filter-group__empty">No matching content.</p>}
      </section>
      {groups.uncategorized.length ? (
        <section
          className="admin-filter-group admin-filter-group--uncategorized"
          aria-label="Global or uncategorized content"
        >
          <h3>Global / Uncategorized <span>{groups.uncategorized.length}</span></h3>
          {renderGroup(groups.uncategorized, groups.match.length)}
        </section>
      ) : null}
      {groups.outside.length ? (
        <section
          className="admin-filter-group admin-filter-group--outside"
          aria-label="Content outside the filter"
        >
          <button
            aria-expanded={showOutside}
            className="admin-filter-group__toggle"
            onClick={() => setShowOutside(value => !value)}
            type="button"
          >
            {showOutside ? 'Hide' : 'Show'} {groups.outside.length} outside filter
          </button>
          {showOutside
            ? renderGroup(
              groups.outside,
              groups.match.length + groups.uncategorized.length,
            )
            : null}
        </section>
      ) : null}
    </>
  );
}
